// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__iFQki","top":"styles_top__bcyYT","block":"styles_block__ngkCq"};